(function (app, ng) {
    app.controller("addSpendingController", addSpendingController);

    addSpendingController.$inject = ["$mdDialog", "marketingTrackerSalesTrackerInputApi", "marketingTrackerSalesTrackerSettingsApi"];
    function addSpendingController($mdDialog, marketingTrackerSalesTrackerInputApi, marketingTrackerSalesTrackerSettingsApi) {
        var $ctrl = this;
        ng.extend($ctrl, {
            spending: {
                Date: '',
                Source: null,
                Amount: 0,
                Notes: '',
                EventGroupId: null,
                AncillaryEventGroupId: null
            },
            isLoading: true,
            spendingCreationSuccess: false,
            hasError: false
        });

        $ctrl.createSpending = function () {
            $ctrl.isLoading = true;
            return marketingTrackerSalesTrackerInputApi.createSpending($ctrl.spending)
                .then(function (response) {
                    $ctrl.isLoading = false;
                    $ctrl.spendingCreationSuccess = true;
                })
                .catch(function () {
                    $ctrl.isLoading = false;
                    $ctrl.hasError = true;
                })
        }

        $ctrl.close = function () {
            if ($ctrl.spendingCreationSuccess)
            {
                $mdDialog.hide($ctrl.spending)
            }
            else
            {
                $mdDialog.cancel();
            }
        }

        function preFillSpendingFromEvent(){
            $ctrl.spending.Date = new Date($ctrl.eventDate).toLocaleDateString();
            $ctrl.spending.Amount = $ctrl.eventCost ? $ctrl.eventCost : 0;
            $ctrl.spending.Notes = "Converted to spend from Marketing Tracker event: " + $ctrl.eventName;
            $ctrl.spending.EventGroupId = $ctrl.eventGroupId;
            $ctrl.spending.AncillaryEventGroupId = $ctrl.ancillaryEventGroupId;
            $ctrl.isLoading = false;
        }


        $ctrl.$onInit = function () {
            $ctrl.currentYear = (new Date()).getUTCFullYear();
            marketingTrackerSalesTrackerSettingsApi.getSources().then(function (response) {
                $ctrl.sources = response;
                preFillSpendingFromEvent();
            })
            .catch(function () {
                $ctrl.hasError = true;
            })
        }

    }
})(window.app, window.angular);